import React, { useState } from "react";
import { X } from "lucide-react";
import "../styles/serviceSection.css";

const ServiceSection = ({ pageTitle, services }) => {
  const [selectedService, setSelectedService] = useState(null);

  const openModal = (service) => {
    setSelectedService(service);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedService(null);
    document.body.style.overflow = "unset";
  };

  // The page title is the page's <h1>; with no title the heading stays an empty <h2>
  const Heading = pageTitle ? "h1" : "h2";

  return (
    <div
      className="container-fluid bg-white py-5 px-3 px-sm-4 px-md-5 px-lg-5"
      style={{ maxWidth: "100%", overflowX: "hidden" }}
    >
      <div className="container" style={{ maxWidth: "1400px" }}>
        <div className="text-center mb-5 mb-sm-5 mb-lg-5 d-inline-block">
          <Heading
            className="fw-bold mb-3"
            style={{
              fontSize: "clamp(1.75rem, 3vw, 3.5rem)",
              letterSpacing: "-0.5px",
              lineHeight: "1.2",
              color: "#0d3b8e",
            }}
          >
            {pageTitle}
          </Heading>
          <div
            className="mx-auto"
            style={{
              height: "4px",
              backgroundColor: "#0d3b8e",
              width: "100%",
              margin: "0 auto",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        {services && Array.isArray(services) && services.length > 0 ? (
          <div className="row g-4 g-sm-4 g-lg-5">
            {services.map((service) => (
              <div
                key={service.id}
                className="col-12 col-sm-6 col-lg-4"
                onClick={() => openModal(service)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="position-relative border border-2 border-light rounded-4 p-4 text-center h-100 shadow-sm card-hover"
                  style={{
                    transition: "all 0.4s ease",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100 rounded-4"
                    style={{
                      background: "rgba(13,110,253,0)",
                      opacity: 0,
                      transition: "opacity 0.4s ease",
                      zIndex: 1,
                    }}
                  ></div>

                  <div className="position-relative z-2 d-flex flex-column align-items-center justify-content-between h-100 gap-3">
                    <div className="position-relative">
                      <img
                        src={service.imgUrl}
                        alt={service.name}
                        loading="lazy"
                        style={{
                          width: "200px",
                          height: "auto",
                          maxWidth: "100%",
                        }}
                      />
                    </div>

                    <h3
                      className="fw-semibold mb-0 service-title"
                      style={{
                        color: "#0d3b8e",
                        fontSize: "clamp(1.125rem, 2vw, 1.75rem)",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {service.name}
                    </h3>

                    <div
                      className="d-flex align-items-center justify-content-center fw-semibold learn-more"
                      style={{
                        color: "#0d6efd",
                        fontSize: "1rem",
                        transition: "all 0.4s ease",
                      }}
                    >
                      Learn more
                      <svg
                        className="ms-2"
                        style={{
                          width: "16px",
                          height: "16px",
                          transition: "transform 0.3s ease",
                        }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      {selectedService && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-4 z-3 animate-fadeIn"
          style={{
            background: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(5px)",
            inset: 0,
            zIndex: 1055,
          }}
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-4 shadow-lg w-100 animate-slideUp"
            style={{
              maxWidth: "800px",
              maxHeight: "90vh",
              overflowY: "auto",
              position: "relative",
              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="position-absolute top-0 end-0 m-3 rounded-circle border-0"
              onClick={() => closeModal()}
              style={{ cursor: "pointer" }}
            >
              <X className="text-secondary" size={30} />
            </div>

            <div className="p-4 border-bottom text-center">
              {/* <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                style={{
                  width: "90px",
                  height: "90px",
                  backgroundColor: "#e7f1ff",
                }}
              >
                <div
                  className="rounded-circle"
                  style={{
                    width: "45px",
                    height: "45px",
                    border: "4px solid #0d3b8e",
                  }}
                ></div>
              </div> */}
              <div className="mb-4 position-relative">
                <img
                  src={selectedService.imgUrl}
                  alt={selectedService.name}
                  style={{ width: "200px", height: "auto" }}
                />
              </div>
              <h3 className="fw-bold fs-3" style={{ color: "#0d3b8e" }}>
                {selectedService.name}
              </h3>
            </div>

            <div className="p-4 text-center">
              <h4
                className="text-uppercase fw-bold small mb-3"
                style={{ color: "#0d3b8e" }}
              >
                Description
              </h4>
              {/* <p className="fs-5 mb-5">{selectedService.description}</p> */}
              <p className="fs-5">{selectedService.description}</p>
              {/* use top styling when using bottom content for next */}
              {/* {selectedService.clients &&
                selectedService.clients.length > 0 && (
                  <>
                    <h4
                      className="text-uppercase fw-bold small mb-4"
                      style={{ color: "#0d3b8e" }}
                    >
                      Trusted By
                    </h4>
                    <div className="row g-3 justify-content-center">
                      {selectedService.clients.map((client, index) => (
                        <div key={index} className="col-12 col-sm-4">
                          <div
                            className="border rounded-4 p-3 bg-light text-center fw-semibold"
                            style={{ color: "#0d3b8e", borderRadius: "10px" }}
                          >
                            {client}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )} */}
            </div>

            <div className="p-4 bg-light text-center rounded-bottom-4">
              <div
                className="d-inline-block px-5 py-2 fw-semibold shadow text-white"
                style={{
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  backgroundColor: "#0d3b8e",
                  borderRadius: "8px",
                }}
                onClick={closeModal}
              >
                Close
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }

        .card-hover:hover {
          transform: translateY(-10px);
          box-shadow: 0 12px 30px rgba(13, 110, 253, 0.2) !important;
          border-color: #0d6efd !important;
          border-radius: 1rem;
          background-color: #ecf6ffff !important;
        }

        .icon-wrap {
          background-color: #e7f1ff;
          transition: all 0.4s ease;
        }

        .card-hover:hover .icon-wrap {
          background-color: #0d3b8e;
          box-shadow: 0 0 20px rgba(13, 110, 253, 0.3);
        }

        .card-hover:hover .icon-wrap div {
          border-color: #fff !important;
        }

        .card-hover:hover .service-title {
          color: #0d6efd !important;
        }

        .card-hover:hover .learn-more {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }

        .card-hover:hover .learn-more svg {
          transform: translateX(4px);
        }

        .card-hover::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 1rem;
          box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.3);
          opacity: 0;
          transition: all 0.5s ease;
        }

        .card-hover:hover::after {
          opacity: 1;
          box-shadow: 0 0 0 6px rgba(13, 110, 253, 0.15);
        }
      `}</style>
    </div>
  );
};

export default ServiceSection;
